import { render } from "./OfferCard.vue?vue&type=template&id=71cc7907"
import script from "./OfferCard.vue?vue&type=script&lang=js"
export * from "./OfferCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__